/*
    App Header
    */

import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { string, func } from 'prop-types'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'

import { userType } from 'models/propTypes'

import Icon from 'components/uiElements/Icon'

require('./Header.scss')

class Header extends Component {
    constructor(props) {
        super(props)
        this.toggleExpanded = this.toggleExpanded.bind(this)
        this.openDesignPage = this.openDesignPage.bind(this)
        this.toggleExpandAccount = this.toggleExpandAccount.bind(this)
        this.onLogoClick = this.onLogoClick.bind(this)
        this.state = {
            expanded: false,
            accountExpanded: false,
        }
    }

    onLogoClick() {
        if (this.props.location === 'dashboard') {
            this.props.refresh()
        }
    }

    toggleExpanded() {
        this.setState((prevState) => ({
            expanded: !prevState.expanded,
            accountExpanded: false,
        }))
    }

    toggleExpandAccount() {
        this.setState((prevState) => ({
            accountExpanded: !prevState.accountExpanded,
            expanded: false,
        }))
    }

    openDesignPage() {
        this.toggleExpanded()
        this.props.openDesignPage()
    }

    render() {
        const { user, location, logout, t } = this.props

        const { accountExpanded } = this.state

        return (
            <nav className={classNames('Header', location)}>
                <div className="inner">
                    <Link to="/dashboard" onClick={this.onLogoClick} className="logo">
                        <img
                            src={`${ASSET_BUCKET}/logo_sugarcube_bug_ikea.svg`}
                            alt={t('common.alt.logo')}
                            className="reg"
                        />
                        <img
                            src={`${ASSET_BUCKET}/logo_sugarcube_bug_ikea.svg`}
                            alt={t('common.alt.logo')}
                            className="white"
                        />
                    </Link>

                    <ul className="cta">
                        <li>
                            <Link to="/dashboard">
                                <button>{t('header.get started')}</button>
                            </Link>
                        </li>
                    </ul>
                    <ul
                        className={classNames('accountPages', { expanded: accountExpanded })}
                        data-testid={accountExpanded ? 'account-pages-expanded' : 'account-pages-collapsed'}
                        role="navigation"
                    >
                        <li>
                            <Link to="/dashboard" onClick={this.toggleExpandAccount}>
                                <button>{t('header.dashboard')}</button>
                            </Link>
                        </li>
                        {user.isLoggedIn && (
                            <li>
                                <Link to="/profile" onClick={this.toggleExpandAccount}>
                                    <button data-testid="account_settings">{t('header.account settings')}</button>
                                </Link>
                            </li>
                        )}
                        <li>
                            <a href="//support.mysugarcube.com/hc/en-us" target="_blank" rel="noopener noreferrer">
                                <button>{t('header.help')}</button>
                            </a>
                        </li>
                        <li>
                            <Link to="/" onClick={this.toggleExpandAccount}>
                                <button>{t('common.learn more')}</button>
                            </Link>
                        </li>
                        {user.isLoggedIn ? (
                            <li>
                                <button onClick={logout} data-testid="logout">
                                    {t('header.logout')}
                                </button>
                            </li>
                        ) : (
                            <>
                                <li>
                                    <Link to="/signup" onClick={this.toggleExpandAccount}>
                                        <button data-testid="signup">{t('header.sign up')}</button>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/login" onClick={this.toggleExpandAccount}>
                                        <button data-testid="login">{t('header.log in')}</button>
                                    </Link>
                                </li>
                            </>
                        )}
                    </ul>
                    <div className="buttons">
                        <button onClick={this.toggleExpandAccount} data-testid="account-pages">
                            <Icon code="user" className="reg" svg />
                            <Icon code="user_white" className="white" svg />
                            <span className="name">{user.firstName}</span>
                        </button>
                        {/*
                        <Icon
                            code="menu"
                            className={classNames('burger')}
                            onClick={this.toggleExpanded}
                        />
                        */}
                    </div>
                </div>
            </nav>
        )
    }
}

Header.propTypes = {
    user: userType.isRequired,
    location: string.isRequired,
    openDesignPage: func.isRequired,
    logout: func.isRequired,
    refresh: func.isRequired,
    t: func.isRequired,
}

export default withTranslation()(Header)
